import { render, staticRenderFns } from "./Anagrafica.vue?vue&type=template&id=2a82bd0e&scoped=true&"
import script from "./Anagrafica.vue?vue&type=script&lang=js&"
export * from "./Anagrafica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82bd0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a82bd0e')) {
      api.createRecord('2a82bd0e', component.options)
    } else {
      api.reload('2a82bd0e', component.options)
    }
    module.hot.accept("./Anagrafica.vue?vue&type=template&id=2a82bd0e&scoped=true&", function () {
      api.rerender('2a82bd0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Anagrafica.vue"
export default component.exports